import Table from './Table';
import Tbody from './Tbody';
import Th from './Th';
import MassOperationsPanel from './MassOperationsPanel';

Table.Tbody = Tbody;
Table.Th = Th;
Table.MassOperationsPanel = MassOperationsPanel;

export {Table, Tbody, Th, MassOperationsPanel};
export default Table;
